export default __webpack_public_path__ + "static/media/HaizeaLovelace.ebddbf16.png";